// extracted by mini-css-extract-plugin
export default {"date_created":"Support_date_created__X4JUv","search_wrapper":"Support_search_wrapper__-Dx6Q"};